import _ from 'underscore';

export default class SupplierProductPricings {
  constructor($scope, UserService) {
    $scope.tabs = [
      {
        title: 'Products',
        items: []
      },
      {
        title: 'Price Groups',
        items: []
      }
    ];

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
    };

    $scope.load_data = function() {
      $scope.loading = true;
      UserService.get_supplier_product_pricings(window.user_id).success(function(data) {
        if (data.success) {
          $scope.set_products(data.product_prices);
          $scope.set_price_groups(data.price_group_prices);
          $scope.loading = false;
        }
      });
    };

    $scope.set_products = function(product_prices) {
      var products = _.groupBy(product_prices, 'product_id');
      var supplier_products = [];
      _.each(products, function(product) {
        var prices = _.values(product);

        var offer_prices = _.pluck(prices, 'offer_fca');
        var offer_fca_min = _.min(offer_prices);
        var offer_fca_max = _.max(offer_prices);

        var most_recent_offer_price = _.max(prices, function(price) {
          return price.offer_date_int;
        });

        var order_prices = _.pluck(prices, 'order_fca');
        var order_fca_min = _.min(order_prices);
        var order_fca_max = _.max(order_prices);

        var most_recent_order_price = _.max(prices, function(price) {
          return price.order_date_int;
        });

        var supplier_product = {
          id: prices[0].id,
          product_id: prices[0].product_id,
          epaper_title: prices[0].epaper_title,
          product_group: prices[0].product_group,
          offer: {
            id: most_recent_offer_price.offer_id,
            date: most_recent_offer_price.offer_date,
            fca_min: offer_fca_min,
            fca_max: offer_fca_max,
          },
          order: {
            id: most_recent_order_price.order_id,
            date: most_recent_order_price.order_date,
            fca_min: order_fca_min,
            fca_max: order_fca_max,
          },
          prices: []
        };

        _.each(prices, function(price) {
          supplier_product.prices.push({
            range: price.range,
            offer_fca: price.offer_fca,
            offer_id: price.offer_id,
            offer_date: price.offer_date,
            order_fca: price.order_fca,
            order_charge: price.order_charge,
            order_id: price.order_id,
            order_date: price.order_date
          });
        });

        supplier_products.push(supplier_product);
      });
      $scope.tabs[0].items = supplier_products;
    };

    $scope.set_price_groups = function(price_group_prices) {
      var price_groups = _.groupBy(price_group_prices, 'price_group_id');
      var supplier_price_groups = [];
      _.each(price_groups, function(price_group) {
        var prices = _.values(price_group);

        var offer_prices = _.pluck(prices, 'offer_fca');
        var offer_fca_min = _.min(offer_prices);
        var offer_fca_max = _.max(offer_prices);

        var most_recent_offer_price = _.max(prices, function(price) {
          return price.offer_date_int;
        });

        var order_prices = _.pluck(prices, 'order_fca');
        var order_fca_min = _.min(order_prices);
        var order_fca_max = _.max(order_prices);

        var most_recent_order_price = _.max(prices, function(price) {
          return price.order_date_int;
        });

        var supplier_price_group = {
          id: prices[0].id,
          price_group: prices[0].price_group,
          price_group_id: prices[0].price_group_id,
          product_group: prices[0].product_group,
          offer: {
            id: most_recent_offer_price.offer_id,
            date: most_recent_offer_price.offer_date,
            fca_min: offer_fca_min,
            fca_max: offer_fca_max,
          },
          order: {
            id: most_recent_order_price.order_id,
            date: most_recent_order_price.order_date,
            fca_min: order_fca_min,
            fca_max: order_fca_max,
          },
          prices: []
        };

        _.each(prices, function(price) {
          supplier_price_group.prices.push({
            range: price.range,
            offer_fca: price.offer_fca,
            offer_id: price.offer_id,
            offer_date: price.offer_date,
            order_fca: price.order_fca,
            order_charge: price.order_charge,
            order_id: price.order_id,
            order_date: price.order_date
          });
        });

        supplier_price_groups.push(supplier_price_group);
      });
      $scope.tabs[1].items = supplier_price_groups;
    };

    $scope.update_pricings = function() {
      $scope.updating_pricings = true;
      UserService.update_supplier_pricings(window.user_id).success(function(data) {
        if (data.success) {
          $scope.updating_pricings = false;
          $scope.load_data();
        }
      });
    };

    $scope.init = function() {
      $scope.selected_tab = 0;
      $scope.load_data();
    };

    $scope.init();
  }
}

SupplierProductPricings.$inject = ['$scope', 'UserService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/supplier-product-pricings.ctrl.js